import olMap from 'ol/Map';
import MousePosition from 'ol/control/MousePosition';
import ScaleLine from 'ol/control/ScaleLine';
import FullScreen from 'ol/control/FullScreen';
import * as olProj from 'ol/proj';
import { OSGB } from "@esdm/gridreference";
import { Coordinate } from "ol/coordinate";

/**
 * Adds the standard map controls: OSGB mouse position (non-touch only),
 * scale line and full-screen.
 */
export class MapControls {

    public constructor(map: olMap, hasTouch: boolean) {
        if (!hasTouch) {
            let mousePositionControl = new MousePosition({
                coordinateFormat: function (coordinate: Coordinate) {
                    let coord27700: Coordinate = olProj.transform(coordinate, "EPSG:3857", "EPSG:27700");
                    // OSGB grid is only valid within the UK extent (EPSG:27700 bounds).
                    // Coordinates outside this range cause GetGridRef to throw because
                    // the internal grid-square lookup returns undefined.
                    const e = coord27700[0];
                    const n = coord27700[1];
                    if (e < 0 || e > 700000 || n < 0 || n > 1300000) {
                        return '';
                    }
                    let osgb = new OSGB();
                    osgb.SetGridCoordinates(e, n);
                    return osgb.GetGridRef(4);
                },
                projection: map.getView().getProjection(),
                className: "custom-mouse-position",
                target: document.getElementById("mouse-position")
            });

            map.addControl(mousePositionControl);
        }

        map.addControl(new ScaleLine());

        let fs = document.createElement('i');
        fs.setAttribute('class', 'fas fa-expand');
        map.addControl(new FullScreen({
            label: fs
        }));
    }
}
